<template>
  <div>
    <div class="w-100 h-100">
      <Nav :rolname="rolname" />
    </div>
    <div class="content h-100" style="background: white">
      <Home
        v-if="page == 'home'"
        @changePage="changePage"
        @mtdBackCampus="mtdBackCampus"
      />
      <Planes v-if="page == 'planes'" @returnHome="returnHome" />
    </div>
    <div class="footer">
      <FooterVue @changePage="changePage" :pageView="page" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Nav from "../../components/ProcHospitalarios/Nav.vue";
import FooterVue from "../../components/ProcHospitalarios/Footer.vue";
import Home from "../../components/ProcHospitalarios/Home.vue";
import Planes from "../../components/ProcHospitalarios/pages/Planes.vue";

export default {
  name: "ProcHospitalariosView",
  components: {
    Nav,
    FooterVue,
    Home,
    Planes
  },
  data() {
    return {
      prefix: 'procHospitalarios',
      area: "procHospitalarios",
      bead: {},
      verifBead: false,
      boxes: [],
      page: "home",
      client: null,
      filter: {},
    };
  },
  props: {
    rolname: String,
  },
  created() {
    this.rol_name = this.rolname;
  },
  methods: {
    ...mapActions(["get", "post"]),

    changePage: function (page) {
      this.page = page;
    },
    returnHome: function () {
      this.page = "home";
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
    mtdBackRol: function () {
      this.$emit("mtdBackRol");
    },
  },
};
</script>
